import {
  TextInput,
  ImageInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  SelectInput,
  SimpleForm,
} from 'react-admin'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import CustomImageField from '../../components/CustomImageField'
import BookToolbar from '../../components/BookToolbar'
import GridContainer from '../../components/GridContainer'
import { validateRequired } from '../../utils/validate'

import KidSeriesStoriesInput from './KidSeriesStoriesInput'

const AGE_RANGE_MAP = {
  under_3: [0, 1, 2],
  '3-5': [3, 4, 5],
  '6-8': [6, 7, 8],
  '9-12': [9, 10, 11, 12],
  '13-15': [13, 14, 15],
  over_15: [16, 17, 18],
}

const AGE_RANGE_CHOICES = [
  { id: 'under_3', name: 'Dưới 3' },
  { id: '3-5', name: '3-5' },
  { id: '6-8', name: '6-8' },
  { id: '9-12', name: '9-12' },
  { id: '13-15', name: '13-15' },
  { id: 'over_15', name: 'Trên 15' },
]

const KidSeriesForm = props => {
  return (
    <SimpleForm
      toolbar={<BookToolbar />}
      redirect="list"
      variant="standard"
      margin="normal"
      {...props}>
      <GridContainer>
        <Grid item xs={12}>
          <TextInput
            source="title"
            fullWidth
            variant="standard"
            validate={validateRequired('Title')}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            source="description"
            resettable
            rows={4}
            fullWidth
            variant="standard"
            multiline
          />
        </Grid>
        <Grid item xs={12}>
          <SelectInput
            source="suitableAges"
            label="Suitable Ages"
            choices={AGE_RANGE_CHOICES}
            fullWidth
            variant="standard"
            format={value => {
              if (!Array.isArray(value)) return value
              return (
                Object.keys(AGE_RANGE_MAP).find(
                  key =>
                    JSON.stringify(AGE_RANGE_MAP[key]) ===
                    JSON.stringify(value),
                ) || ''
              )
            }}
            parse={value => AGE_RANGE_MAP[value] || []}
          />
        </Grid>
        <Grid item xs={12}>
          <ReferenceArrayInput
            label="Topics"
            source="topicIds"
            reference="topics"
            filter={{ type: ['kids_story', 'all'] }}>
            <AutocompleteArrayInput
              optionText="name"
              fullWidth
              variant="standard"
              filterToQuery={searchText => ({
                name: { $iLike: `%${searchText}%` },
              })}
            />
          </ReferenceArrayInput>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            List Stories
          </Typography>
          <KidSeriesStoriesInput source="storyIds" />
        </Grid>
        <Grid item xs={12}>
          <ImageInput
            source="coverImages"
            label="Cover image"
            accept="image/*"
            multiple={false}
            format={value => {
              if (value && typeof value === 'object' && value.original)
                return {
                  src: `${process.env.REACT_APP_S3_URL}/${value.original}`,
                }
              return value
            }}>
            <CustomImageField source="src" title="Cover image" />
          </ImageInput>
        </Grid>
      </GridContainer>
    </SimpleForm>
  )
}

export default KidSeriesForm
